export default __webpack_public_path__ + "static/media/V340_CoC.ba872261.pdf";